import { createSelector } from 'reselect';
import { getBreakpointMaxWidth, getWindowHeight, getWindowWidth } from './breakpoint';
import { getCurrentPageNumber } from './page';

export default (state, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const getPatternsCountToRender = createSelector(
    [getBreakpointMaxWidth, getWindowHeight], (width, height) => {
        let { columns, rows } = 0;
        if (width > 300) {
            columns = Math.floor(width / 400);
            rows = Math.ceil(height / 400);
        }
        else {
            columns = Math.floor(width / 150);
            rows = Math.ceil(height / 150);
        }
        return Math.ceil(columns * rows * 1.4);
    });

export const getPatternPerPage =
    state => state.stolo.ui.patternGallery.patternPerPage;

export const getGalleryThumbnailType = createSelector([getBreakpointMaxWidth],
    width => width < 300 ? 'gallery' : 'medium',
);

export const getAppBarType = createSelector([getBreakpointMaxWidth],
    width => width < 1024 ? 'small' : 'full',
);

export const getPatternsPerPageLimit = state => state.stolo.ui.patternGallery.patternPerPage;

export const showLoader = (state, totalHits) => {
    const currentPageNumber = getCurrentPageNumber(state);
    const pageCount = Math.ceil(totalHits / getPatternsPerPageLimit(state));
    if (pageCount > 1 && pageCount !== currentPageNumber) {
        return true;
    }
};

export const getPatternsStripeCount = createSelector(
    [getWindowWidth], width => {
        if (!width) {
            return 2;
        }
        const columns = Math.floor(width / 110);
        return Math.ceil(columns);
    });



// WEBPACK FOOTER //
// ./src/reducers/ui.patterngallery.js